import React from 'react';

/* Loading placeholder. Background-position shimmer, cheap to animate;
   reduced-motion handled by the CSS rule in app.css. */
export default function Skeleton({ width = '100%', height = 12, radius = 'var(--radius-sm)', circle = false, style }) {
  return (
    <span
      aria-hidden
      className="sh-skeleton"
      style={{
        display: 'block', width, height: circle ? width : height,
        borderRadius: circle ? '50%' : radius,
        ...style,
      }}
    />
  );
}
